import { render, staticRenderFns } from "./ManifestacaoSituacaoBadge.vue?vue&type=template&id=38f23140&scoped=true&"
import script from "./ManifestacaoSituacaoBadge.vue?vue&type=script&lang=js&"
export * from "./ManifestacaoSituacaoBadge.vue?vue&type=script&lang=js&"
import style0 from "@/styles/manifestacao.scss?vue&type=style&index=0&id=38f23140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f23140",
  null
  
)

export default component.exports